import React from 'react';
import { motion } from 'framer-motion';
import { Cloud, Lock, Settings as SettingsIcon } from 'lucide-react';

const fadeInUp = {
  initial: { opacity: 0, y: 60 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: "easeOut" }
};

const staggerContainer = {
  initial: "initial",
  whileInView: "animate",
  viewport: { once: true },
  variants: {
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  }
};

const infraItems = [
  { icon: Cloud, title: "Google Cloud Run", desc: "Powered by Google's scalable infrastructure" },
  { icon: Lock, title: "Secure Access", desc: "Token-based authentication and encryption" },
  { icon: SettingsIcon, title: "Rate Limits", desc: "Credit control for cost management" }
];

const InfrastructureSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-16"
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 font-heading text-primary-foreground">
            Trusted <span className="gradient-text-brand">Infrastructure</span>
          </h2>
          <p className="text-xl text-foreground max-w-3xl mx-auto">
            Built on enterprise-grade technology for reliability and performance
          </p>
        </motion.div>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
          {...staggerContainer}
        >
          {infraItems.map((item, index) => (
            <motion.div
              key={index}
              className="text-center p-8 bg-card rounded-xl shadow-xl hover-lift border border-border"
              variants={fadeInUp}
            >
              <item.icon className="h-16 w-16 text-primary mx-auto mb-6" />
              <h3 className="text-2xl font-bold mb-3 text-card-foreground font-heading">{item.title}</h3>
              <p className="text-foreground">{item.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default InfrastructureSection;